<template>
  <div><h1>contract</h1></div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
